
import * as PropTypes from 'prop-types'

import { CustomerCategoryCount } from '../../../store/pages/diary/types';
import ReservationInfoLabel from '../diary/reservationInfoLabel';

interface CompetitorCountsProps {
    totalStockForBooking: number;
    totalStockDistributed: number;
}

const StockCounts = (props: CompetitorCountsProps) => {
    const { totalStockForBooking, totalStockDistributed } = props;

    const cls = totalStockDistributed >= totalStockForBooking ? 'reception-event-count-complete' : '';

    return totalStockForBooking > 0
        ? <div key='stock' className='reception-booking-stock-indicator'><ReservationInfoLabel quantity={totalStockDistributed} totalQuantity={totalStockForBooking} icon='shopping-cart' showWhenComplete={false} className={cls} /></div>
        : <div key='stock' className='reception-booking-stock-indicator'></div>
}


StockCounts.contextTypes = {
    t: PropTypes.func
}

export default StockCounts;